import { ROLES, CONSTANTS } from 'config';
import { forIn } from 'lodash';
import template from './admin-company-detail.html';
import './admin-company-detail.styl';

function adminCompanyComponent($scope, $state, $stateParams, uiGridConstants,
  AuthService, ReportService, ConfigService) {

  'ngInject';

  this.companyId = $stateParams.id;
  this.companyName = $stateParams.name;

  this.state = $state.current;
  this.params = $stateParams;

  this.roles = ROLES;

  this.getOpts = (c) => {
    const opts = [];
    forIn(c, (value, key) => {
      opts.push({
        value: key,
        label: value.name,
      });
    });
    return opts;
  };

  this.getVersionOpts = () => this.getOpts(CONSTANTS.VERSION);
  this.getDesignTypeOpts = () => this.getOpts(CONSTANTS.PROJECT_TYPE);
  this.getBuildingUsageOpts = () => this.getOpts(CONSTANTS.BUILDING_USAGE);

  const correctTotalPaginationTemplate = "<div role=\"contentinfo\" class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div role=\"menubar\" class=\"ui-grid-pager-control\"><button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle\"><div class=\"first-bar\"></div></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle prev-triangle\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div class=\"last-triangle next-triangle\"></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div class=\"last-triangle\"><div class=\"last-bar\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{(((grid.options.paginationCurrentPage-1)*grid.options.paginationPageSize)+1)}} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{(grid.options.paginationCurrentPage*grid.options.paginationPageSize>grid.options.totalItems?grid.options.totalItems:grid.options.paginationCurrentPage*grid.options.paginationPageSize)}} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>";

  this.gridOptions = {
    language: 'es',
    onRegisterApi: (gridApi) => {
      this.gridApi = gridApi;

      gridApi.pagination.on.paginationChanged($scope, (pageNumber, pageSize) => {
        ConfigService.set(CONSTANTS.PAGE_SIZE, pageSize);
      });
    },
    columnDefs: [
      { field: 'name', displayName: 'Sector', cellTooltip: true, cellTemplate: '<div class="ui-grid-cell-contents"><a ng-href="report/{{row.entity.id}}" class="report-link">{{row.entity.name}}</a><md-tooltip>{{row.entity.name}}</md-tooltip></div>' },
      { field: 'meredicteVersion', displayName: 'Versión', cellFilter: 'version', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getVersionOpts() }, width: 100 },
      { field: 'code', displayName: 'Código' },
      { field: 'evaluator', displayName: 'Evaluador' },
      { field: 'province', displayName: 'Provincia' },
      { field: 'postal_code', displayName: 'C.P.' },
      { field: 'design_type', displayName: 'Diseño', cellFilter: 'designType', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getDesignTypeOpts() } },
      { field: 'building_usage', displayName: 'Uso', cellFilter: 'buildingUsage', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getBuildingUsageOpts() } },
      { field: 'createdAt', displayName: 'Creado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center' },
      { field: 'updatedAt', displayName: 'Actualizado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center' },
      { field: 'nrg', displayName: 'NRG', enableFiltering: false, cellFilter: 'number: 2' },
      { field: 'actions', displayName: 'Acciones', enableColumnMenu: false, enableFiltering: false, cellClass: 'grid-align-center', cellTemplate: '<div><tsz-report-actions report=row.entity></tsz-report-actions> <!--{{row.entity.id}}--></div>' },
    ],
    enableFiltering: false,
    enableHorizontalScrollbar: 0,
    enableVerticalScrollbar: 0,
    paginationPageSizes: [5, 10, 25, 50],
    paginationPageSize: ConfigService.get(CONSTANTS.PAGE_SIZE, 10),
    paginationTemplate: correctTotalPaginationTemplate,
  };

  this.toggleFiltering = () => {
    console.log('Toggle filtering');
    this.gridOptions.enableFiltering = !this.gridOptions.enableFiltering;
    this.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
  };

  this.loadReports = (id) => {
    ReportService.company_reports(id)
    .then((result) => {
      this.gridOptions.data = result;
    }).catch((err) => {
      console.error(err);
    });
  };

  this.gotoCreateReport = () => {
    $state.go('report');
  };

  $scope.$on('report_deleted', () => {
    this.loadReports();
  });

  //
  // INIT
  //

  this.loadReports(this.companyId);

}

export default {
  template,
  controller: adminCompanyComponent,
};



// WEBPACK FOOTER //
// ./src/containers/admin-company-detail/index.js